import { Inject, Injectable } from 'ng-metadata/core';


@Injectable('mwLocaleService')
export class LocaleService {

    constructor(
        @Inject('tmhDynamicLocale') private tmhDynamicLocale,
        @Inject('$locale') private $locale,
        @Inject('$rootScope') private $rootScope) {

        $rootScope.$on('$translateChangeSuccess', (e, l) => {
            this.setLocale(l.language);
        });
    }

    setLocale(locale: string) {
        // trying to save an unnecessary request of locale data here, since en-us locale is
        // the default locale data that is bundled with angularjs, no need to fetch
        // and change the locale data if 'en' is requested because the locale data is the same for both
        if ( locale === 'en' && this.$locale.id === 'en-us' ) {
            locale = 'en-us';
        }

        // convert zh_CN and zh_TW to standard locales zh-cn and zh-tw
        if ( locale.indexOf('zh') === 0 ) {
            locale = locale.toLowerCase();
            locale = locale.replace('_', '-');
        }

        return this.tmhDynamicLocale.set(locale);
    }

    getLocale() {
        return this.$locale;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/data-formatting/locale.service.ts